import Service, { service } from '@ember/service'
import { task } from 'ember-concurrency'
import { waitFor } from '@ember/test-waiters'
import type ContentfulClientService from 'teacher-ui-client/services/contentful-client'
import { openUrlInNewWindow } from 'teacher-ui-client/download-file/utils'
import type { Log } from '@blakeelearning/log'
import type { LogArgument } from 'rollbar'
import { parse } from 'teacher-ui-client/utils/uri'

export default class BigBooksService extends Service {
  @service contentfulClient!: ContentfulClientService

  @service log!: Log

  downloadBookNotes = task(
    { restartable: true },
    waitFor(async (bookCode: string) => {
      try {
        const url = await this.fetchBookNotesUrl(bookCode)
        if (url) {
          openUrlInNewWindow(url)
        }
      } catch (e) {
        this.log.error(`unknown error downloading book notes with book code: ${bookCode}`, e as LogArgument)
      }
    }),
  )

  /**
   * @returns the url of the first pdf found for the given book code.
   * NOTE: UI design supports one book notes pdf per book.
   */
  async fetchBookNotesUrl(bookCode: string) {
    const assets = await this.contentfulClient.getBookNotesForBookCode(bookCode)
    const urlString = assets[0]?.fields?.file?.url
    if (urlString) return parse(urlString).href
  }
}

declare module '@ember/service' {
  interface Registry {
    'big-books': BigBooksService
  }
}
